import styled from '@emotion/styled';

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
`;

export const TableHeader = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  textAlign: 'left',
  fontSize: '0.95rem',
  width: '100%',
  border: 0,
  paddingTop: '0.8rem',
  paddingBottom: '0.8rem',
  paddingLeft: '1.5rem',
  paddingRight: '1.5rem',
  gap: '1rem',
  backgroundColor: theme.colors.gray[0],
  borderBottom: `1px solid ${theme.colors.gray[4]}`,
}));
